import React from 'react';
import styles from './spinLoader.module.scss';

const SpinLoader = ({ loading, wrapperClassName, className, text }) => {
  return loading ? (
    <div className={`${styles.loaderWrapper} ${wrapperClassName}`}>
      <div className={`${styles['lds-roller']} ${className}`}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      {text && <div className={styles.text}>{text}</div>}
    </div>
  ) : null;
};

SpinLoader.defaultProps = {
  wrapperClassName: '',
  className: ''
};

export default SpinLoader;
